import React, { useState } from 'react';
import DS_Chip from 'mui/components/elements/DS_Chip';

import { pushGTMDayFilterAdded, pushGTMDayFilterRemoved } from 'utils/gtm';

import { StyledFiltersWrapper, StyledFilters } from './DS_StyledDailyFilters';

const DS_DailyFilters = ({ sortedDates, selectedDates, setSelectedDates, setResetDates }) => {
  const [transitionalSelected, setTransitionalSelected] = useState([]);
  const handleClick = date => {
    if (!selectedDates.some(d => d.formatted === date.formatted)) {
      setResetDates(false);
      setTransitionalSelected(prevTransitional => [...prevTransitional, date.formatted]);

      setTimeout(() => {
        setTransitionalSelected(prevTransitional => prevTransitional.filter(formatted => formatted !== date.formatted));
        setSelectedDates(prevDates => [...prevDates, date]);
      }, 500); //delay before reordering

      pushGTMDayFilterAdded(date);
    }
  };

  const handleClose = date => {
    const newSelectedDates = selectedDates.filter(d => d.formatted !== date.formatted);
    setSelectedDates(newSelectedDates);
    pushGTMDayFilterRemoved(date);
    if (newSelectedDates.length === 0) setResetDates(true);
  };

  return (
    <StyledFiltersWrapper data-test="daily-filters-wrapper">
      <StyledFilters data-test="daily-filters">
        {sortedDates.map(date => (
          <DS_Chip
            key={date.formatted}
            text={date.formatted}
            selected={selectedDates.some(d => d.formatted === date.formatted)}
            handleClick={() => handleClick(date)}
            handleClose={() => handleClose(date)}
            transitional={transitionalSelected.includes(date.formatted)}
          />
        ))}
      </StyledFilters>
    </StyledFiltersWrapper>
  );
};

export default DS_DailyFilters;
